

import { loadMasterAppointmentsData } from "../../hooks/loading/loadMasterAppointmentsData";
import { loadMasterMediaAndSurvey } from "../../hooks/loading/loadMasterMediaAndSurvey";
import { loadMasterProfileData } from "../../hooks/loading/loadMasterProfileData";
import { loadMasterScheduleData } from "../../hooks/loading/loadMasterScheduleData";

export const loadMasterData = async (masterId, dispatch) => {
    try {
        if (!masterId) return;

        await Promise.all([
            loadMasterProfileData(masterId, dispatch),
            loadMasterScheduleData(masterId, dispatch),
            loadMasterAppointmentsData(masterId, dispatch),
            loadMasterMediaAndSurvey(masterId, dispatch),
        ]);

        // 
    } catch (error) {
        // console.error("Error loading master data:", error);
        throw error;
    }
};
